import useBookingGetters from './getters';
import useBookingActions from './actions';
import useBookingUtilities from './other/useBookingUtilities';
import useBookingOnSetup from './other/useBookingOnSetup';
import useBookingWatchers from './other/useBookingWatchers';

export default function useBooking (locationId, bookingId, preSelected) {
  const {
    tierPriceToLocationPrice,
  } = useBookingUtilities(locationId);

  const {
    location,
    bookings,
    currentTime,
    defaultBooking,
    bookingChanges,
    bookingInStore,
    booking,
    startTime,
    paid,
    bookingStationTimesChanges,
    bookingStationTimesInStore,
    bookingStationTimes,
    experiences,
    stations,
    getExperienceStations,
    getExperienceTiers,
    getExperienceCoupons,
    getExperienceDiscounts,
  } = useBookingGetters(locationId, bookingId);

  const {
    bookingConflict,
    setConflictBooking,
    longestTierLength,
    editBooking,
    addBookingStationTime,
    removeBookingStationTime,
    undoRemoveBookingStationTime,
    setStartingTime,
    setStartingTimeNow,
    toggleMarkAsPaid,
    stationAction,
    tierAction,
    experienceAction,
    couponAction,
    discountAction,
    saving,
    isLoading,
    storeBooking,
    cancelBooking,
  } = useBookingActions(
    locationId,
    location,
    bookings,
    currentTime,
    booking,
    bookingInStore,
    bookingChanges,
    startTime,
    paid,
    bookingStationTimes,
    bookingStationTimesInStore,
    bookingStationTimesChanges,
    experiences,
    stations,
    getExperienceStations,
    getExperienceTiers,
    tierPriceToLocationPrice,
  );

  useBookingOnSetup(bookingId, defaultBooking, bookingChanges, preSelected, addBookingStationTime, editBooking, setConflictBooking);
  useBookingWatchers(booking, bookings, setConflictBooking);

  return {
    tierPriceToLocationPrice,
    location,
    bookings,
    currentTime,
    booking,
    startTime,
    experiences,
    stations,
    getExperienceStations,
    getExperienceTiers,
    getExperienceCoupons,
    getExperienceDiscounts,

    bookingConflict,
    editBooking,
    longestTierLength,
    addBookingStationTime,
    removeBookingStationTime,
    undoRemoveBookingStationTime,
    setStartingTime,
    setStartingTimeNow,
    toggleMarkAsPaid,
    stationAction,
    tierAction,
    experienceAction,
    couponAction,
    discountAction,
    saving,
    isLoading,
    storeBooking,
    cancelBooking,
  };
}
